var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { getAccountIdFromStorage } from 'helpers/customBranding';
import COMPLETE_EXAM_ATTEMPT from 'mutations/complete-exam-attempt.graphql';
import showNotification from 'notifications/notifications';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import useAuthentication from './use-authentication';
import useLogger from './use-logger';
export const useSubmitExam = () => {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { getUserIdFromToken, getExamIdFromToken } = useAuthentication();
    const [completeExamAttempt] = useMutation(COMPLETE_EXAM_ATTEMPT);
    const logger = useLogger();
    const navigate = useNavigate();
    const submitExam = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsSubmitting(true);
        const fields = {
            userId: getUserIdFromToken(),
            examId: getExamIdFromToken(),
        };
        const accountId = getAccountIdFromStorage();
        try {
            yield completeExamAttempt({
                variables: {
                    fields,
                    accountId,
                },
            });
            navigate('/finish');
        }
        catch (error) {
            logger.error(error);
            showNotification('error', t('REVIEW.COMPLETE_ATTEMPT_ERROR'));
        }
        setIsSubmitting(false);
    });
    return { isSubmitting, submitExam };
};
